import { __require as n } from "./_Set.js";
import { __require as q } from "./noop.js";
import { __require as s } from "./_setToArray.js";
var e, t;
function p() {
  if (t) return e;
  t = 1;
  var r = n(), a = q(), i = s(), o = 1 / 0, u = r && 1 / i(new r([, -0]))[1] == o ? function(_) {
    return new r(_);
  } : a;
  return e = u, e;
}
export {
  p as __require
};
